import $ from 'jquery';

import 'popper.js';
import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
import 'bootstrap/js/dist/tooltip';

let _config = window['_config'] || {};

window.app = window.app || {};
window.app.modules =  window.app.modules || {};

let app = window.app;


import initModulesInScope from "@elements/init-modules-in-scope";
app.initModules = function ($scope) {
    console.warn('\'app.initModules\' is going to be deprecated and should not be used anymore. Please import and use \'initModulesInScope\' from \'./scripts/initModulesInScope\' instead.');
    initModulesInScope($scope);
};

$.loadScript = function (url) {
    console.warn('\'$.loadScript\' is going to be deprecated and should not be used anymore. Please use \'import\' for local files or import and use \'loadScript\' for external resources.');

    return import('@elements/load-script').then(function (loadScript) {
        return loadScript.default(url);
    });
};
import './scripts/common';

/**********************************
 *
 *      Site Stuff
 *
 * ********************************/

import * as shariff from './scripts/shariff';
app.modules.shariff = shariff.initInScope;

import * as bvToggleTab from './scripts/bv-toggle-tab';
app.bvToggleTab = bvToggleTab.init;

/*import * as videoJs from './scripts/videoJs';
app.modules.videoJs = videoJs.initInScope;*/

import * as lightbox from '@elements/lightbox';
app.modules.lightbox = lightbox.initInScope;


import * as swiper from './scripts/swiper';

app.modules.productContentTeaserSwiper = swiper.createInitInScope({
        sliderContainer: '.js-swiper-product-content-teaser',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 20,
        scrollbar: {
            findElement: $swiperContainer => $swiperContainer.find('.js-swiper__scrollbar'),
            draggable: true,
        },
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        },
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 4,
                spaceBetween: 40
            }
        },
    });


import * as productDetailSwiper from './scripts/product-detail-swiper';
app.modules.productDetailSwiper = productDetailSwiper.initInScope;

import * as showMore from './scripts/show-more';
app.modules.showMore = showMore.initInScope;

import * as smoothScroll from '@elements/smooth-scroll';
let options = {
    offset: 120
};

smoothScroll.init(options, {});
smoothScroll.initInScope();

import * as numberSpinner from '@elements/number-spinner';
app.modules.numberSpinner = numberSpinner.initInScope;

import * as centerActiveTab from './scripts/center-active-tab';
app.modules.centerActiveTab = centerActiveTab.initInScope;

import * as loadStoreInfo from './scripts/load-store-info';
app.modules.loadStoreInfo = loadStoreInfo.initInScope;

import * as manufacturerLibs from './scripts/manufacturer-libs';
app.manufacturerLibs = manufacturerLibs.init;

import * as ratingStars from './scripts/rating-stars';
app.modules.ratingStars = ratingStars.initInScope;

import * as ajaxModal from './scripts/ajax-modal';
app.modules.ajaxModal = ajaxModal.initInScope;

import * as consentOverlay from './scripts/consent-overlay';
app.modules.consentOverlay = consentOverlay.initInScope;
console.log('Test');


(function( $ ){
    "use strict";

    /* -> _config._preload = Load this functions first */
    if (_config['_preload']) {
        $.each( _config['_preload'], function( _key, _val ){
            if( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ){
                window.app[_key]();
            }
        });
    }

    /* -> _config = Load all others (not _preload and _reload) */
    $.each( _config, function( _key, _val ){
        // console.log('key',_key)
        // console.log('val',_val)
        if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' && _key != '_reload' && _key != '_preload' ) ){
            window.app[_key]();
        }
    });

    /* -> _config._reload = Load the ajaxInclued and others after the rest */
    if (_config['_reload']) {
        $.each( _config['_reload'], function( _key, _val ){
            if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ) ){
                window.app[_key]();
            }
        });
    }

    initModulesInScope();
})($);